import {applyMiddleware, compose, createStore} from 'redux';
import reducers from '../reducers/index';
import {createBrowserHistory} from 'history'
import {routerMiddleware} from 'connected-react-router';
import thunk from 'redux-thunk';
import {SIGNOUT_USER_SUCCESS, USER_DATA, USER_DATA_UPDATE, USER_TOKEN_EXPIRE} from "../constants/ActionTypes";
import {authorizeSocket} from "../util/Socket";

const history = createBrowserHistory();
const routeMiddleware = routerMiddleware(history);
const localStorageMiddleware = ({ getState }) => {
  return next => action => {
    const result = next(action);
    const states = getState();
    if ([ SIGNOUT_USER_SUCCESS, USER_DATA, USER_DATA_UPDATE ].includes(result.type)) {
      localStorage.setItem('user', JSON.stringify(states.auth.currentUser));
    }
    if([USER_TOKEN_EXPIRE, SIGNOUT_USER_SUCCESS].includes(result.type))
      authorizeSocket(states.auth.token)
    return result;
  };
};

const middlewares = [thunk, routeMiddleware, localStorageMiddleware];
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default function configureStore(initialState) {

  const store = createStore(reducers(history), initialState,
    composeEnhancers(applyMiddleware(...middlewares)));
  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../reducers/index', () => {
      const nextRootReducer = require('../reducers/index');
      store.replaceReducer(nextRootReducer);
    });
  }
  return store;
}
export {history};
